import React from 'react';
import { ResponsivePie } from '@nivo/pie';

function UsageRatePie(props) {
    // console.warn('props di usageRatePie: ', props);
    return (
        <div style={ props.height || { height: '500px' }}>
                  <ResponsivePie data={props.metagame} id="deckName" value="usageRate" margin={{ top: 40, right: 80, bottom: 80, left: 80 }} innerRadius={0.5}
                    padAngle={0.7}
                    cornerRadius={3}
                    activeOuterRadiusOffset={8}
                    borderWidth={1}
                    borderColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                0.2
                            ]
                        ]
                    }}
                    sortByValue={true}
                    arcLinkLabelsSkipAngle={10}
                    arcLinkLabelsTextColor="#333333"
                    arcLinkLabelsThickness={2}
                    arcLinkLabelsColor={{ from: 'color' }}
                    arcLabelsSkipAngle={10}
                    arcLabelsTextColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                2
                            ]
                        ]
                    }}
            />
            </div>
    );
}

export default UsageRatePie;